export default {"src":"/_next/static/media/logo.6d584e17.svg","height":25,"width":87,"blurWidth":0,"blurHeight":0};